import React from 'react';

const NumberFormatSimple = ({ number }) => {
  parseFloat(number)
  const formatNumber = (number) => {
    return number.toLocaleString('es-ES', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
  };

  return <>{formatNumber(number)}</>;
};

export default NumberFormatSimple;